// extracted by mini-css-extract-plugin
export default {"container":"card-overlay-state_container__dmIo2","all":"card-overlay-state_all__1ar7o"};